// extracted by mini-css-extract-plugin
module.exports = {"button__skeleton":"styles_button__skeleton__wG1_8","skeleton-animation":"styles_skeleton-animation__LHjXz","desktop__only":"styles_desktop__only__tVrxn"};